import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = { class: "card-header card-header-stretch" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("抽赏记录")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vxe_button = _resolveComponent("vxe-button")!
  const _component_vxe_form_item = _resolveComponent("vxe-form-item")!
  const _component_vxe_form = _resolveComponent("vxe-form")!
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_vxe_pager = _resolveComponent("vxe-pager")!
  const _component_NewBoxModal = _resolveComponent("NewBoxModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_vxe_form, {
          data: _ctx.formData,
          onSubmit: _ctx.submitEvent
        }, {
          default: _withCtx(() => [
            _createVNode(_component_vxe_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_vxe_button, {
                  type: "button",
                  status: "primary",
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#kt_modal_new_box"
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_vxe_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_vxe_button, {
                  type: "submit",
                  status: "primary"
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_button, {
                  type: "button",
                  onClick: _ctx.onCancel
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data", "onSubmit"])
      ]),
      _createVNode(_component_vxe_table, {
        data: _ctx.tableData,
        "row-config": { isHover: true }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_vxe_column, {
            field: "id",
            title: "ID"
          }),
          _createVNode(_component_vxe_column, {
            field: "name",
            title: "名称"
          }),
          _createVNode(_component_vxe_column, {
            field: "enabled_display",
            title: "启用"
          }),
          _createVNode(_component_vxe_column, {
            field: "box_record_count",
            title: "已抽数"
          }),
          _createVNode(_component_vxe_column, {
            field: "profit_total_expect",
            title: "预期盈亏"
          }),
          _createVNode(_component_vxe_column, {
            field: "profit_total",
            title: "总盈亏"
          }),
          _createVNode(_component_vxe_column, {
            field: "profit_total_internal",
            title: "真实盈亏"
          }),
          _createVNode(_component_vxe_column, {
            field: "updated_at",
            title: "更新时间",
            width: "200"
          }),
          _createVNode(_component_vxe_column, {
            field: "updated_by",
            title: "更新人"
          }),
          _createVNode(_component_vxe_column, {
            title: "操作",
            width: "180"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_button, {
                type: row.enabled ? 'danger' : 'success',
                size: "small",
                onClick: ($event: any) => (_ctx.toggleStatus(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(row.enabled ? '停用' : '启用'), 1)
                ]),
                _: 2
              }, 1032, ["type", "onClick"]),
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                onClick: ($event: any) => (_ctx.$router.push({ name: 'box_records', params: { box_info_id: _ctx.route.params.id, id: row.id } }))
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"]),
      _createVNode(_component_vxe_pager, {
        "current-page": _ctx.page.currentPage,
        "onUpdate:current-page": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.page.currentPage) = $event)),
        "page-size": _ctx.page.pageSize,
        "onUpdate:page-size": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.page.pageSize) = $event)),
        total: _ctx.page.totalResult,
        layouts: [
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total',
      ],
        onPageChange: _ctx.onPageChange
      }, null, 8, ["current-page", "page-size", "total", "onPageChange"])
    ]),
    _createVNode(_component_NewBoxModal, { add_box: _ctx.add_box }, null, 8, ["add_box"])
  ], 64))
}